export default function () {
    var node = this, nodes = [node];
    while (node = node.parent) {
        nodes.push(node);
    }
    return nodes;
}
